/**
 * Rows per read in a collection's initial load. On native each batch crosses
 * the Capacitor bridge as one message, so a larger batch raises peak memory
 * with no clear gain in load time: at 97k guest messages on a 2 GB Android
 * emulator, two 5,000-row launches overlapped the 1,000-row ones, and 25,000
 * rows added about 170 MiB to the app process. The adapter is patched to page
 * by primary key, so the batch size no longer decides how much SQLite re-reads.
 * ADR-0117 has the measurements.
 *
 * Its own module, free of imports, so the sync benchmark can read the value the
 * app ships without loading the app's database.
 */
export const INITIAL_READ_BATCH_ROWS = 1000;
